import { useEffect } from "react";
import contactImg from "../assets/img/contact.png";
import CommonHero from "../components/common/CommonHero";
import GetTheBestTravelDeal from "../components/common/GetTheBestTravelDeal";
import ContactForm from "../components/contact/Contact";
import HowItWork from "../components/contact/HowItWorks";

const ContactPage = () => {
  useEffect(() => {
    document.getElementById("title-page").innerHTML = "TripNest | Contact us";
  }, []);
  return (
    <div>
      <CommonHero imgUrl={contactImg} text="Contact Us" />
      <ContactForm />
      <HowItWork />
      <GetTheBestTravelDeal />
    </div>
  );
};

export default ContactPage;
